import styled from '@emotion/styled';

import Box from '~/common/components/Box';
import { TOP_NAV_HEIGHT } from '~/common/components/GlobalLayout/PageLayout/Styled';
import Grid from '~/common/mui/Grids/Grid';

export const StyledClassifyGrid = styled<any>(Grid)`
  grid-template-columns: 1fr;
  grid-gap: 0;
  height: 100%;
  border-left: 0px solid ${(props) => props.theme.colors?.gray[200]};
`;

function getPointerEvents(props: { disabled?: boolean }): string {
  return props.disabled ? 'none' : 'default';
}

function getOpacity(props: { disabled?: boolean }): number {
  return props.disabled ? 0.6 : 1;
}

export const StyledClassifyRightContainer = styled<any>(Box)`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: calc(100vh - ${TOP_NAV_HEIGHT});
  border-left: none;
  background-color: white;
  border-top-right-radius: 6px;
  border-bottom-right-radius: 6px;
  background-color: ${(props) => props.theme.colors?.white};
  pointer-events: ${getPointerEvents};
  opacity: ${getOpacity};
`;

export const StyledClassifyHeader = styled<any>(Box)`
  display: flex;
  justify-content: space-between;
  height: 72px;
  padding: 20px 24px;
  border-bottom: 1px solid ${(props) => props.theme.colors?.gray[200]};
`;

export const StyledClassifyBody = styled<any>(Box)`
  display: grid;
  grid-template-columns: 3fr 1fr;
  grid-column-gap: 36px;
  flex: 1;
  min-height: 0;
`;

export const StyledClassifyFooter = styled<any>(Box)`
  display: flex;
  justify-content: flex-end;
  padding: 16px 32px;
  height: 72px;
  border-top: 1px solid ${(props) => props.theme.colors?.gray[200]};
`;
